/* AE Delivery Promise Widget — v3 (header inline + EN/VI i18n).
 *
 * BACKEND LOGIC (haversine, 5-tier, cutoff, federal holidays, weekend skip,
 * localStorage 'ae_zip_code') — UNCHANGED from build #2. Only UI text now
 * routes through an i18n translation system so EN/VI can be switched at runtime.
 *
 * Origin = 76060 Kennedale TX; tier cutoff = 12 (tier1) / 14 (tier2-5), CT.
 */
(function () {
  'use strict';

  // ═══════════════════════════════════════════════════════════════════
  // i18n
  // ═══════════════════════════════════════════════════════════════════
  var STORAGE_LANG = 'ae_lang';
  var DEFAULT_LANG = 'en';

  var I18N = {
    en: {
      'logo.tagline':         'DFW LOCAL DELIVERY',
      'search.placeholder':   'Search products...',
      'header.signin':        'Sign In',
      'header.account':       'Account',
      'cart.label':           'Cart',
      'nav.cuisine':          'Shop by Cuisine',
      'nav.category':         'Shop by Category',
      'nav.new':              'New Arrivals',
      'nav.bestsellers':      'Bestsellers',
      'nav.deals':            '🔥 Deals',
      'nav.refer':            'Refer & Save 10%',
      'delivery.choose_zip':  'Enter ZIP',
      'delivery.placeholder': 'Enter ZIP to see',
      'sheet.title':          '📍 Enter your ZIP code',
      'sheet.subtitle':       'See exact delivery date for your address',
      'action.confirm':       'Confirm'
    },
    vi: {
      'logo.tagline':         'GIAO NỘI THÀNH DFW',
      'search.placeholder':   'Tìm sản phẩm...',
      'header.signin':        'Đăng nhập',
      'header.account':       'Tài khoản',
      'cart.label':           'Giỏ hàng',
      'nav.cuisine':          'Mua theo ẩm thực',
      'nav.category':         'Mua theo danh mục',
      'nav.new':              'Hàng mới',
      'nav.bestsellers':      'Bán chạy',
      'nav.deals':            '🔥 Giảm giá',
      'nav.refer':            'Giới thiệu, giảm 10%',
      'delivery.choose_zip':  'Nhập ZIP',
      'delivery.placeholder': 'Nhập ZIP để xem',
      'sheet.title':          '📍 Nhập ZIP để xem ngày giao',
      'sheet.subtitle':       'Xem chính xác ngày giao đến địa chỉ của bạn',
      'action.confirm':       'Xác nhận'
    }
  };

  // Tier copy is NOT in the user-facing dict above (it's runtime-computed),
  // so keep it here. Both langs maintained side-by-side.
  var TIER_COPY = {
    en: {
      tier1_same: '🚚 Same-day delivery',
      tier1_next: '🚚 Tomorrow',
      tier2:      '✓ Next-day delivery',
      tier3:      '📦 2-day delivery',
      tier4:      '📦 3-5 day delivery',
      tier5:      '📦 5-7 day delivery',
      err_short:  'Enter 5-digit ZIP',
      err_nonus:  'US ZIP codes only',
      err_unknown:'ZIP not found',
      err_load:   'Cannot load data — try again',
      success:    'Saved'
    },
    vi: {
      tier1_same: '🚚 Giao trong ngày',
      tier1_next: '🚚 Giao ngày mai',
      tier2:      '✓ Giao ngày mai',
      tier3:      '📦 Giao 2 ngày',
      tier4:      '📦 Giao 3-5 ngày',
      tier5:      '📦 Giao 5-7 ngày',
      err_short:  'Nhập ZIP 5 số',
      err_nonus:  'Chỉ ship trong US',
      err_unknown:'ZIP không tìm thấy',
      err_load:   'Không tải được dữ liệu',
      success:    'Đã lưu'
    }
  };

  function getCurrentLang() {
    try { var v = window.localStorage.getItem(STORAGE_LANG); return v === 'vi' ? 'vi' : 'en'; }
    catch (e) { return DEFAULT_LANG; }
  }
  function setLang(lang) {
    if (lang !== 'en' && lang !== 'vi') return;
    try { window.localStorage.setItem(STORAGE_LANG, lang); } catch (e) {}
    applyTranslations();
    document.documentElement.setAttribute('lang', lang);
    document.dispatchEvent(new CustomEvent('aef:lang-changed', { detail: { lang: lang } }));
  }
  function applyTranslations() {
    var lang = getCurrentLang();
    var dict = I18N[lang] || I18N.en;
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var key = el.getAttribute('data-i18n');
      if (dict[key] != null) el.textContent = dict[key];
    });
    document.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-placeholder');
      if (dict[key] != null) el.placeholder = dict[key];
    });
    document.querySelectorAll('[data-i18n-aria-label]').forEach(function (el) {
      var key = el.getAttribute('data-i18n-aria-label');
      if (dict[key] != null) el.setAttribute('aria-label', dict[key]);
    });
    document.querySelectorAll('[data-aef-lang-current]').forEach(function (el) {
      el.textContent = lang === 'vi' ? 'VI' : 'EN';
    });
  }
  function wireLangSwitchers() {
    document.querySelectorAll('[data-aef-lang]').forEach(function (root) {
      if (root._aefLangInit) return;
      root._aefLangInit = true;
      var trigger = root.querySelector('[data-aef-lang-trigger]');
      var menu    = root.querySelector('[data-aef-lang-menu]');
      if (!trigger || !menu) return;
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = menu.hidden === false;
        menu.hidden = open;
        trigger.setAttribute('aria-expanded', String(!open));
      });
      root.querySelectorAll('[data-aef-lang-set]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setLang(btn.getAttribute('data-aef-lang-set'));
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        });
      });
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !menu.hidden) {
          menu.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });
  }

  // ═══════════════════════════════════════════════════════════════════
  // Delivery widget — backend logic (UNCHANGED from build #2)
  // ═══════════════════════════════════════════════════════════════════
  var ORIGIN_ZIP = '76060';
  var STORAGE_ZIP = 'ae_zip_code';
  var TZ = 'America/Chicago';

  var TIER_DEFS = {
    tier1: { maxMiles:  20, cutoffHour: 12, transitMin: 0, transitMax: 0, sameDay: true  },
    tier2: { maxMiles: 400, cutoffHour: 14, transitMin: 1, transitMax: 1, sameDay: false },
    tier3: { maxMiles: 700, cutoffHour: 14, transitMin: 2, transitMax: 2, sameDay: false },
    tier4: { maxMiles:  Infinity, cutoffHour: 14, transitMin: 3, transitMax: 5, sameDay: false },
    tier5: { maxMiles:  Infinity, cutoffHour: 14, transitMin: 5, transitMax: 7, sameDay: false }
  };
  //   028-029 RI, 030-038 NH, 039-049 ME, 050-059 VT, 967-968 HI, 980-994 WA, 995-999 AK
  var FAR_PREFIX_RE = /^(02[89]|03\d|04\d|05\d|967|968|98\d|99\d)/;

  var WEEKDAY_VI = ['Chủ Nhật','Thứ Hai','Thứ Ba','Thứ Tư','Thứ Năm','Thứ Sáu','Thứ Bảy'];
  var WEEKDAY_EN = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function haversineMiles(lat1, lng1, lat2, lng2) {
    var R = 3958.8, toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad, dLng = (lng2 - lng1) * toRad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(a)));
  }

  var zipDbPromise = null;
  function loadZipDb(jsonUrl) {
    if (zipDbPromise) return zipDbPromise;
    zipDbPromise = fetch(jsonUrl, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('ZIP db ' + r.status); return r.json(); })
      .then(function (p) { return p && p.zips ? p.zips : p; })
      .catch(function (err) { console.error('[aef-delivery]', err); zipDbPromise = null; return null; });
    return zipDbPromise;
  }
  function getCentroid(db, zip) {
    if (!db) return null;
    var v = db[zip];
    return Array.isArray(v) && v.length === 2 ? { lat: v[0], lng: v[1] } : null;
  }
  function getTier(distance, zip) {
    if (FAR_PREFIX_RE.test(zip)) return 'tier5';
    if (distance <= TIER_DEFS.tier1.maxMiles) return 'tier1';
    if (distance <= TIER_DEFS.tier2.maxMiles) return 'tier2';
    if (distance <= TIER_DEFS.tier3.maxMiles) return 'tier3';
    return 'tier4';
  }

  // ----- federal holidays -----
  function nthWeekday(year, month, weekday, n) {
    var d = new Date(Date.UTC(year, month, 1));
    var offset = (weekday - d.getUTCDay() + 7) % 7;
    return new Date(Date.UTC(year, month, 1 + offset + (n - 1) * 7));
  }
  function lastWeekday(year, month, weekday) {
    var lastDay = new Date(Date.UTC(year, month + 1, 0));
    var offset = (lastDay.getUTCDay() - weekday + 7) % 7;
    return new Date(Date.UTC(year, month, lastDay.getUTCDate() - offset));
  }
  function ymdUTC(d) {
    return d.getUTCFullYear() + '-' +
      String(d.getUTCMonth() + 1).padStart(2, '0') + '-' +
      String(d.getUTCDate()).padStart(2, '0');
  }
  function holidaysForYear(year) {
    var thx = nthWeekday(year, 10, 4, 4);
    return [
      new Date(Date.UTC(year, 0, 1)),
      nthWeekday(year, 0, 1, 3),
      nthWeekday(year, 1, 1, 3),
      lastWeekday(year, 4, 1),
      new Date(Date.UTC(year, 6, 4)),
      nthWeekday(year, 8, 1, 1),
      nthWeekday(year, 9, 1, 2),
      new Date(Date.UTC(year, 10, 11)),
      thx,
      new Date(Date.UTC(year, thx.getUTCMonth(), thx.getUTCDate() + 1)),
      new Date(Date.UTC(year, 11, 25))
    ];
  }
  var holidaySet = null;
  function ensureHolidays(forYear) {
    if (holidaySet && holidaySet.year === forYear) return holidaySet.set;
    var s = {};
    holidaysForYear(forYear).concat(holidaysForYear(forYear + 1))
      .forEach(function (d) { s[ymdUTC(d)] = true; });
    holidaySet = { year: forYear, set: s };
    return s;
  }
  function isHoliday(d) { return !!ensureHolidays(d.getUTCFullYear())[ymdUTC(d)]; }
  function isWeekend(w) { return w === 0 || w === 6; }
  function addDaysUTC(d, n) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + n)); }
  function nextBusinessDay(d) {
    var cur = addDaysUTC(d, 1);
    while (cur.getUTCDay() === 0 || cur.getUTCDay() === 6 || isHoliday(cur)) cur = addDaysUTC(cur, 1);
    return cur;
  }
  function addBusinessDays(d, n) {
    var cur = d;
    for (var i = 0; i < n; i++) cur = nextBusinessDay(cur);
    return cur;
  }

  function nowInTexas() {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short'
    });
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var wk = { Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6 };
    var h = parseInt(parts.hour, 10); if (h === 24) h = 0;
    return {
      year:  parseInt(parts.year, 10),
      month: parseInt(parts.month, 10) - 1,
      day:   parseInt(parts.day, 10),
      hour:  h,
      minute:parseInt(parts.minute, 10),
      weekday: wk[parts.weekday]
    };
  }
  function getShipDate(tier, txNow) {
    var today = new Date(Date.UTC(txNow.year, txNow.month, txNow.day));
    var def = TIER_DEFS[tier];
    var past = txNow.hour >= def.cutoffHour;
    var ok = !isWeekend(txNow.weekday) && !isHoliday(today) && !past;
    return ok ? today : nextBusinessDay(today);
  }
  function getDeliveryDates(tier, shipDate) {
    var def = TIER_DEFS[tier];
    if (def.sameDay) return { min: shipDate, max: shipDate };
    var mn = addBusinessDays(shipDate, def.transitMin);
    var mx = def.transitMax > def.transitMin ? addBusinessDays(shipDate, def.transitMax) : mn;
    return { min: mn, max: mx };
  }

  // ----- formatting -----
  function fmtDate(d, lang) {
    var arr = lang === 'vi' ? WEEKDAY_VI : WEEKDAY_EN;
    return arr[d.getUTCDay()] + ' ' + d.getUTCDate() + '/' + (d.getUTCMonth() + 1);
  }
  function fmtRange(a, b, lang) {
    if (ymdUTC(a) === ymdUTC(b)) return fmtDate(a, lang);
    return fmtDate(a, lang) + ' – ' + fmtDate(b, lang);
  }

  // True iff `target` is the literal calendar day after `today` (UTC compare).
  function isLiteralNextDay(today, target) {
    return ymdUTC(addDaysUTC(today, 1)) === ymdUTC(target);
  }

  function buildPromise(tier, zip, txNow, lang) {
    var ship = getShipDate(tier, txNow);
    var deliv = getDeliveryDates(tier, ship);
    var today = new Date(Date.UTC(txNow.year, txNow.month, txNow.day));
    var sameDay = ymdUTC(ship) === ymdUTC(today) && tier === 'tier1';
    var copy = TIER_COPY[lang] || TIER_COPY.en;
    var p;
    if (tier === 'tier1' && sameDay) {
      p = copy.tier1_same;
    } else if (tier === 'tier1') {
      // BUG-W (2026-05-21): "Tomorrow"/"ngày mai" must drop on Saturday + Sunday
      // even though Monday is the literal next calendar day from Sunday. Shop
      // is closed Sat–Sun, so a customer ordering on the weekend doesn't
      // experience "tomorrow delivery" — they get "Monday delivery". Gate the
      // qualifier on (literal-next-day) AND (today is a business day).
      if (isLiteralNextDay(today, deliv.min) && !isWeekend(txNow.weekday)) {
        p = copy.tier1_next + ' · ' + fmtDate(deliv.min, lang);
      } else {
        p = '🚚 ' + fmtDate(deliv.min, lang);
      }
    } else if (tier === 'tier2') {
      // BUG-W (2026-05-21): tier2 "✓ Next-day delivery" is misleading on Friday
      // (ship=Fri, deliv=Mon via weekend-skipped transit ≈ +3 days) and on
      // Sat/Sun (ship=Mon, deliv=Tue). Only keep the "Next-day" qualifier when
      // delivery genuinely lands on the literal calendar next day from today.
      if (isLiteralNextDay(today, deliv.min) && !isWeekend(txNow.weekday)) {
        p = copy.tier2 + ' · ' + fmtDate(deliv.min, lang);
      } else {
        p = '✓ ' + fmtDate(deliv.min, lang);
      }
    } else if (tier === 'tier3') {
      p = copy.tier3 + ' · ' + fmtDate(deliv.max, lang);
    } else if (tier === 'tier4') {
      p = copy.tier4 + ' · ' + fmtRange(deliv.min, deliv.max, lang);
    } else {
      p = copy.tier5 + ' · ' + fmtRange(deliv.min, deliv.max, lang);
    }
    return { promise: p, zip: zip, tier: tier };
  }

  // ═══════════════════════════════════════════════════════════════════
  // Render
  // ═══════════════════════════════════════════════════════════════════
  function render(root, state) {
    var lang = getCurrentLang();
    var promiseEls = root.querySelectorAll('[data-aef-dw-promise]');
    var editEls    = root.querySelectorAll('[data-aef-dw-edit]');
    if (!promiseEls.length) return;

    promiseEls.forEach(function (el) { el.classList.add('is-fading'); });
    setTimeout(function () {
      if (state.zip) {
        promiseEls.forEach(function (el) { el.textContent = state.promise; });
        editEls.forEach(function (el) { el.textContent = state.zip; });
        root.setAttribute('data-tier', state.tier || '');
      } else {
        var dict = I18N[lang] || I18N.en;
        var placeholder = dict['delivery.placeholder'] || 'Enter ZIP to see';
        var defaultZip = dict['delivery.choose_zip'] || 'Enter ZIP';
        promiseEls.forEach(function (el) { el.textContent = placeholder; });
        editEls.forEach(function (el) { el.textContent = defaultZip; });
        root.removeAttribute('data-tier');
      }
      promiseEls.forEach(function (el) { el.classList.remove('is-fading'); });
    }, 80);
  }

  // ----- LocalStorage helpers -----
  function safeGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function safeSet(k, v) { try { window.localStorage.setItem(k, v); return true; } catch (e) { return false; } }

  // ----- Modal/sheet -----
  function openSheet(root) {
    var modal = root.querySelector('[data-aef-dw-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var input = modal.querySelector('input[type="text"]');
    input && setTimeout(function () { input.focus(); input.select(); }, 30);
    function onKey(e) { if (e.key === 'Escape') { closeSheet(root); document.removeEventListener('keydown', onKey); } }
    root._aefKeyHandler = onKey;
    document.addEventListener('keydown', onKey);
  }
  function closeSheet(root) {
    var modal = root.querySelector('[data-aef-dw-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (root._aefKeyHandler) { document.removeEventListener('keydown', root._aefKeyHandler); root._aefKeyHandler = null; }
    var pill = root.querySelector('[data-aef-dw-pill]');
    pill && pill.focus();
  }

  function resolveZip(root, zip, opts) {
    var lang = getCurrentLang();
    var copy = TIER_COPY[lang] || TIER_COPY.en;
    var errorEl = root.querySelector('[data-aef-dw-error]');
    var jsonUrl = root.getAttribute('data-aef-dw-db');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    if (!/^\d{5}$/.test(zip)) {
      if (zip.length > 0 && /[^0-9]/.test(zip)) showErr(errorEl, copy.err_nonus);
      else showErr(errorEl, copy.err_short);
      return;
    }
    loadZipDb(jsonUrl).then(function (db) {
      if (!db) { showErr(errorEl, copy.err_load); return; }
      var origin = getCentroid(db, ORIGIN_ZIP);
      var dest   = getCentroid(db, zip);
      if (!origin) { showErr(errorEl, copy.err_load); return; }
      if (!dest)   { showErr(errorEl, copy.err_unknown); return; }
      var miles = haversineMiles(origin.lat, origin.lng, dest.lat, dest.lng);
      var tier  = getTier(miles, zip);
      var state = buildPromise(tier, zip, nowInTexas(), lang);
      render(root, state);
      /* P0 freeze fix 2026-05-17: opts.silent = true skips the
         safeSet + cache-invalidate + aef:zone-changed dispatch chain.
         Auto-fill / cosmetic re-render paths (called from the
         ae-zone-ready listener) pass silent so they don't re-trigger
         zone-detection.resolve() and create an infinite loop:
           resolve → ae-zone-ready → syncFromZone → aeRecomputeDelivery
                  → resolveZip → safeSet + dispatch aef:zone-changed
                  → resolve → ae-zone-ready → … (page freezes)
         Explicit user-submit + lang-change paths leave silent unset,
         so they still write LS + invalidate cache + signal the cart
         popup / free-shipping bar to re-render (BUG-P behaviour). */
      if (!opts || !opts.silent) {
        safeSet(STORAGE_ZIP, zip);
        /* BUG-P: when the visitor changes ZIP via the widget, the cached
           `ae_zone_v1` entry (set by zone-detection.js) is now stale —
           its `postal` field still points at the previous location.
           Invalidate it explicitly and signal zone-detection to
           re-resolve in-page so the mini-cart popup + free-shipping bar
           pick up the correct threshold without a reload. */
        try { localStorage.removeItem('ae_zone_v1'); } catch (e) {}
        try {
          window.dispatchEvent(new CustomEvent('aef:zone-changed', { detail: { zip: zip } }));
        } catch (e) {
          /* CustomEvent constructor missing (very old browsers) — fall back */
          try {
            var evt = document.createEvent('Event');
            evt.initEvent('aef:zone-changed', true, true);
            window.dispatchEvent(evt);
          } catch (e2) {}
        }
      }
      if (opts && opts.successEl) {
        opts.successEl.hidden = false;
        opts.successEl.textContent = copy.success;
        setTimeout(function () {
          opts.successEl.hidden = true;
          opts.successEl.textContent = '';
          closeSheet(root);
        }, 1500);
      }
    });
  }
  function showErr(el, msg) { if (!el) return; el.hidden = false; el.textContent = msg; }

  function refreshFromStorage(root) {
    var zip = safeGet(STORAGE_ZIP);
    if (zip && /^\d{5}$/.test(zip)) {
      var input = root.querySelector('[data-aef-dw-form] input[type="text"]');
      input && (input.value = zip);
      resolveZip(root, zip, null);
    } else {
      render(root, { zip: null });
    }
  }

  // ----- init each widget instance -----
  function initOne(root) {
    if (root._aefInit) return;
    root._aefInit = true;

    // Wire every pill trigger in this root (mobile + desktop instances both)
    root.querySelectorAll('[data-aef-dw-pill]').forEach(function (pill) {
      pill.addEventListener('click', function (e) { e.preventDefault(); openSheet(root); });
    });

    root.querySelectorAll('[data-aef-dw-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeSheet(root); });
    });

    var form = root.querySelector('[data-aef-dw-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="text"]');
        var success = root.querySelector('[data-aef-dw-success]');
        var zip = (input && input.value || '').trim();
        resolveZip(root, zip, { successEl: success });
      });
    }

    root.querySelectorAll('[data-aef-dw-suggest]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var zip = chip.getAttribute('data-zip') || (chip.textContent || '').trim().slice(0, 5);
        var input = root.querySelector('[data-aef-dw-form] input[type="text"]');
        var success = root.querySelector('[data-aef-dw-success]');
        if (input) input.value = zip;
        resolveZip(root, zip, { successEl: success });
      });
    });

    refreshFromStorage(root);
  }

  // ═══════════════════════════════════════════════════════════════════
  // Boot
  // ═══════════════════════════════════════════════════════════════════
  function boot() {
    applyTranslations();
    document.documentElement.setAttribute('lang', getCurrentLang());
    wireLangSwitchers();
    document.querySelectorAll('[data-aef-delivery]').forEach(initOne);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-render delivery widget when lang changes (state preserved in localStorage)
  document.addEventListener('aef:lang-changed', function () {
    document.querySelectorAll('[data-aef-delivery]').forEach(refreshFromStorage);
  });

  // ═══════════════════════════════════════════════════════════════════
  // BUG-S — Sync ZIP picker UI from zone-detection (2026-05-17, polished)
  // ═══════════════════════════════════════════════════════════════════
  // Whenever zone-detection.js resolves a postal — via ipapi (first visit),
  // 30-day cache (return visit), cart shipping address (post-checkout), OR
  // explicit user input (priority-0 path via ae_zip_code) — keep the
  // picker UI in sync.
  //
  // Initial implementation (commit 5cb6936) added a source filter that
  // skipped source='user-zip' on the theory that the picker's own submit
  // handler would have already rendered the new ZIP locally. Boss observed
  // a real edge case where that filter caused a stale pill:
  //
  //   - Customer travelling (IP detected ZIP A = 76101 / DFW)
  //   - Wants to order for a relative at ZIP B = 32311 (FL)
  //   - Submits B via the picker
  //   - Pill kept showing A until full reload
  //
  // Two separate concerns were conflated:
  //   (a) "Should we save this postal to localStorage.ae_zip_code?" — NO,
  //       only the explicit submit handler does that; otherwise IP guess
  //       could overwrite a manual choice.
  //   (b) "Should the pill UI reflect this postal?" — ALWAYS YES, as long
  //       as we have a postal to show.
  //
  // The old code answered both with the same filter. Polish fix: source
  // filter only governs (a) (we still don't write LS here), but the UI
  // sync in (b) runs unconditionally whenever ze.postal exists.
  //
  // Race-safety: bot/fallback/non-us sources never carry a postal, so the
  // early `!ze.postal` return covers them implicitly.
  // P0 freeze fix 2026-05-17: pass {silent: true} so the auto-fill path
  // doesn't trigger resolveZip's BUG-P dispatch chain. Without this, every
  // ae-zone-ready fires aeRecomputeDelivery → resolveZip → safeSet +
  // aef:zone-changed → zone-detection re-resolves → ae-zone-ready → …
  // infinite recursion → browser "Page Unresponsive".
  window.aeRecomputeDelivery = function (zip) {
    if (!zip || !/^\d{5}$/.test(String(zip))) return;
    document.querySelectorAll('[data-aef-delivery]').forEach(function (root) {
      try { resolveZip(root, String(zip), { silent: true }); } catch (e) {}
    });
  };

  // P0 freeze fix 2026-05-17: synchronous re-entry guard. Belt-and-suspenders
  // alongside resolveZip's silent flag — covers any other future code path
  // that might re-fire ae-zone-ready synchronously while we're already
  // inside the listener.
  var _aefZoneReadyBusy = false;

  function syncFromZone() {
    if (_aefZoneReadyBusy) return;
    _aefZoneReadyBusy = true;
    try {
      var ze = window.AE_ZONE;
      if (!ze || !ze.postal) return;
      // (b) Cosmetic sync — runs for every source that carries a postal.
      // render() in resolveZip will also touch [data-aef-dw-edit] on its
      // own 80 ms timeout; setting textContent here first gives the user
      // an instant visual update (no fade gap) and is idempotent with the
      // later render() write.
      var sel = '[data-aef-dw-edit], [data-aef-zip-display],'
              + ' .aef-delivery-trigger-zip, .aef-delivery-zip-text,'
              + ' .aef-mobile-delivery-zip';
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = ze.postal;
      });
      // Recompute the delivery date for every widget instance via the
      // silent path — no LS write, no aef:zone-changed dispatch, just
      // render. Breaks the recursion at its source.
      window.aeRecomputeDelivery(ze.postal);
    } catch (e) {} finally {
      _aefZoneReadyBusy = false;
    }
  }

  // Subscribe for the normal case (event fires after widget boot).
  document.addEventListener('ae-zone-ready', syncFromZone);
  // Race-safe: if zone-detection's resolve() already completed before this
  // listener attached (cache-hit synchronous path), pick up window.AE_ZONE
  // on the spot.
  syncFromZone();
})();
